<template lang="">
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Aprobaci&oacute;n | Seleccionar Periodo y Municipalidad
                    </v-col>
                </v-row>

                <v-row class="col-md-12">
                    <v-col cols="12" md="4" sm="4" xs="12" >
                        <v-select
                            v-model="periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            return-object
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            menu-props="auto"
                            @change="obtnenerDepartamentos"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="4" sm="4" xs="12">
                        <v-select
                            v-model="departamentoId"
                            :items="deptos"
                            class="required"
                            dense
                            outlined
                            :loading="ddDeptosLoading"
                            label="Departamento"
                            item-text="nombreDepartamento"
                            item-value="id"
                            return-object
                            menu-props="auto"
                            :rules="[
                                selectRequired(
                                    'Departamento'
                                )
                            ]"
                            
                        >
                            <template slot='selection' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }}
                                        </v-col>
                                    </v-row>
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    <v-row>
                                        <v-col cols="12">
                                            {{ item.codigo }} - {{ item.nombreDepartamento }} <br/> 
                                        </v-col>
                                    </v-row>
                                </template>
                        </v-select>
                    </v-col>

                    <v-col cols="12" md="4" sm="4" xs="12">
                        <v-btn
                            :disabled="deptos.length<=0 || departamentoId <=0 "
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            @click="obtnenerMunicipiosPorDepto();"
                        >
                            Buscar
                            <v-icon right>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            <v-card-text>

                <v-data-table
                        :headers="headers"
                        :items="municipios"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                        dense
                    >

                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.codigo }}</td>
                            <td>{{ item.nombreMunicipio }}</td>
                            <td>
                                <v-btn class="ma-2" 
                                    small tile outlined 
                                    color="indigo"
                                    :to="{
                                        name: 'aprobacion-municipalidades-preguntas',
                                        params: { municipalidadId:item.idMunicipio, periodoId: item.idPeriodo }
                                    }"
                                >
                                    <v-icon left>mdi-check</v-icon> Aprobar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>


        </v-card>
        <!-- Fin:: v-card-->
            
                        
        
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import validations from "@/core/untils/validations.js";

import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_DEPARTAMENTOS_APROBADOR_PERIODO} from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_MUNICIPIOS_POR_APROBADOR } from "@/core/services/store/catalogos/municipio.module";
export default {

    data(){ 
        return{
            tableLoading: false,
            tableFilter:'',
            ddPeriodosLoading: false,
            periodoMedicionId:0,
            periodos:[],
            ddDeptosLoading: false,
            departamentoId: 0,
            deptos:[],
            municipios:[],
            ...validations
        }
    },

    methods: {
        

         //!Obtener los periodos para la tabla
        async obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            await this.$store
                .dispatch(OBTENER_PERIODOS, 1)
                .then(res => {
                    if(res.status==200){
                        this.periodos = this.$store.state.periodomedicion.periodos;
                    }
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },


        //!Obtener los departamentos para la tabla
        async obtnenerDepartamentos(){
            this.ddDeptosLoading = true;
            this.deptos=[];
            
            await this.$store
                .dispatch(OBTENER_DEPARTAMENTOS_APROBADOR_PERIODO,{aprobadorRevisorId: this.currentUser.id, periodoId: this.periodoMedicionId.id})
                .then(res => {
                    if(res.status==200){
                        this.deptos = this.$store.state.departamento.departamentos;
                    }
                    this.ddDeptosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddDeptosLoading = false;
                });

        },


        //!Obtener las etnias para la tabla
        async obtnenerMunicipiosPorDepto(){

            this.tableLoading=true;
            //this.ddMunicipiosLoading = true;
            this.municipios=[];
            
            await this.$store
                .dispatch(OBTENER_MUNICIPIOS_POR_APROBADOR, {departamentoId: this.departamentoId.id, periodoId: this.periodoMedicionId.id, usuarioId: this.currentUser.id})
                .then(res => {
                    if(res.status==200){
                        this.municipios = this.$store.state.municipio.municipios;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },


    },

    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Inicio", route: "/dashboard-revisor-aprobador" },
            { title: "Revision" },
            { title: "Municipalidades" }
        ]);
    },

    created(){
        //this.obtnenerDepartamentos();
        this.obtnenerPeriodosMedicion();
       // console.log(this.currentUser)
    },

     computed:{
        ...mapGetters(["currentUser"]),

        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                {
                    text: "Codigo Municipio",
                    value: "codigo"
                },
                {
                    text: "Municipio",
                    value: "nombreMunicipio"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
     }


}

</script>
<style lang="scss">

</style>>